// Shows a table of contents for the article with mobile and desktop styles

import React, { useState } from 'react';

import { Bit } from '@blockworks/ui/bit';
import { Button, Card, Divider, Prose } from '@blockworks/ui/components';
import { ChevronDownIcon, ChevronUpIcon } from '@blockworks/ui/icon';

export const WebTableOfContents = ({ contentId }: { contentId?: string }) => (
    <div className="hidden lg:block">
        <Card p={1} withBorder>
            <Prose.ToC contentId={contentId} />
        </Card>
    </div>
);

const MobileContent = ({ expandable, contentId }: { expandable?: boolean; contentId?: string }) => {
    const [isExpanded, setIsExpanded] = useState(!expandable);
    const actionIcon = isExpanded ? ChevronDownIcon : ChevronUpIcon;

    if (expandable) {
        return (
            <Bit.div w="full" border={1} p={2} bgColor="base" borderRadius="md">
                {isExpanded && <Prose.ToC onClick={() => setIsExpanded(!isExpanded)} />}
                {isExpanded && <Divider orientation="horizontal" />}
                <Button
                    onClick={() => setIsExpanded(!isExpanded)}
                    size="sm"
                    w="full"
                    center
                    variant="ghost"
                    trailingIcon={actionIcon}
                >
                    Table of Contents
                </Button>
            </Bit.div>
        );
    }

    return (
        <Bit.div w="full" my={5} border={1} p={2} bgColor="base" borderRadius="none">
            <Prose.ToC contentId={contentId} />
        </Bit.div>
    );
};

export const MobileTableOfContents = ({ hasSidebar, contentId }: { hasSidebar?: boolean; contentId?: string }) => {
    let className = 'left-1/2 translate-x-[-50%] z-50';
    // Articles in the Research App have a leftside sidebar, so we move the TOC to the right
    if (hasSidebar) {
        className += ' md:left-[60%]';
    }
    return (
        <Bit.div
            role="listbox"
            display={{ initial: 'block', lg: 'hidden' }}
            className={className}
            pos="fixed"
            bottom={4}
            w="max"
            shadow="md"
        >
            <MobileContent expandable contentId={contentId} />
        </Bit.div>
    );
};
